import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Icon from './Icon';
import i18n from '../../src/i18n/translate';
import { pickDataAttributes } from '../Util';

export default class ModalHeader extends Component {
  static propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    descriptionComponentClass: PropTypes.elementType,
    canClickOff: PropTypes.bool,
    onCancel: PropTypes.func,
    titleId: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    titleComponentClass: PropTypes.elementType,
    closeButton: PropTypes.bool,
    closeButtonIcon: PropTypes.string
  };

  static defaultProps = {
    className: '',
    closeButton: true,
    closeButtonIcon: 'close',
    description: '',
    descriptionComponentClass: 'h3'
  }

  render() {
    const { className, canClickOff, onCancel, title, titleId, closeButton,
      closeButtonIcon, description, titleComponentClass,
      descriptionComponentClass: DescriptionComponent
    } = this.props;
    const dataAttributes = pickDataAttributes(this.props);

    return (
      <Modal.Header className={className} closeButton={false} onHide={onCancel}>
        {canClickOff && closeButton &&
          <Button
            {...dataAttributes}
            aria-label={i18n.t("Close")}
            className="pull-right close-link"
            data-action="close-modal"
            onClick={onCancel}
          >
            <Icon iconType={closeButtonIcon} />
          </Button>
        }
        {title && <Modal.Title id={titleId} componentClass={titleComponentClass}>{title}</Modal.Title>}
        {description && <DescriptionComponent className="modal-description">{description}</DescriptionComponent>}
      </Modal.Header>
    );
  }
}
